// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"61858cf4","167":"a65b8cd3","250":"62551e0a","455":"a244b48e","644":"fdac536b","712":"5478ae96","931":"483d0df1","955":"21acc824","977":"b3671515"}[chunkId] + ".chunk.js";
};